import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    document.addEventListener('click', this.closeOnClickOutside)
    document.addEventListener('turbo:load', this.handleTurboLoad.bind(this))
    document.addEventListener('turbo:render', this.handleTurboLoad.bind(this))
    document.addEventListener('turbo:before-render', this.handleTurboLoad.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnClickOutside)
    document.removeEventListener('turbo:load', this.handleTurboLoad)
    document.removeEventListener('turbo:render', this.handleTurboLoad)
    document.removeEventListener('turbo:before-render', this.handleTurboLoad)
  }

  handleTurboLoad() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add('hidden')
    }
  }

  toggle(event) {
    event.stopPropagation()
    this.menuTarget.classList.toggle('hidden')
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target) && !this.menuTarget.classList.contains('hidden')) {
      this.menuTarget.classList.add('hidden')
    }
  }
}
